import { useMemo, useState } from "react"
import { TextField, InputAdornment, IconButton } from "@mui/material"
import { Search, Close } from "@mui/icons-material"
import PropTypes from "prop-types"
import { debounce } from "lodash"

export default function MetricsSearch({ metricsSearchValue, setMetricsSearchValue }) {
  const [localSearchValue, setLocalSearchValue] = useState(metricsSearchValue)

  const debouncedSetMetricsSearchValue = useMemo(
    () => debounce((search) => setMetricsSearchValue(search), 200),
    [setMetricsSearchValue],
  )

  function handleChange(event) {
    setLocalSearchValue(event.target.value)
    debouncedSetMetricsSearchValue(event.target.value)
  }

  function handleClear() {
    setLocalSearchValue("")
    setMetricsSearchValue("")
  }

  return <div className="metrics-search-wrapper">
    <TextField
      variant="outlined"
      autoFocus
      size="small"
      fullWidth
      placeholder="Search for metrics"
      value={localSearchValue}
      onChange={handleChange}
      slotProps={{
        input: {
          classes: {
            root: "metrics-search-input",
          },
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: metricsSearchValue !== "" && (
            <InputAdornment position="end">
              <IconButton onClick={handleClear}>
                <Close />
              </IconButton>
            </InputAdornment>
            ),
         },
      }}
    />
  </div>
}

MetricsSearch.propTypes = {
  metricsSearchValue: PropTypes.string.isRequired,
  setMetricsSearchValue: PropTypes.func.isRequired,
}
